/* Lilly&Mae quick add: bouton AJOUTER AU PANIER sur les cartes produit, ouvre un choix taille/couleur */
(function () {
  if (window.lmQuickAddLoaded) return;
  window.lmQuickAddLoaded = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';

  function money(cents) {
    try {
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function img(src, width) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  var css = '' +
    '.product-block .lm-native-qb{display:none!important}' +
    '.product-block .lm-atc{display:block;width:100%;margin:10px 0 2px;padding:13px 10px;background:#121212;color:#fff!important;border:1px solid #121212;border-radius:0;font-size:12px;font-weight:600;letter-spacing:.14em;line-height:1;text-transform:uppercase;text-align:center;text-decoration:none;cursor:pointer;transition:background-color .2s,color .2s}' +
    '.product-block .lm-atc:hover,.product-block .lm-atc:focus-visible{background:#fff;color:#121212!important}' +
    'body.lmqa-lock{overflow:hidden}' +
    '.lmqa{position:fixed;inset:0;z-index:2147483000;display:none}' +
    '.lmqa.is-open{display:block}' +
    '.lmqa__overlay{position:absolute;inset:0;background:rgba(0,0,0,.45)}' +
    '.lmqa__panel{position:absolute;right:0;top:0;bottom:0;width:440px;max-width:100%;background:#fff;color:#121212;overflow-y:auto;padding:28px 24px 24px;box-shadow:-8px 0 30px rgba(0,0,0,.15);animation:lmqaIn .25s ease}' +
    '@keyframes lmqaIn{from{transform:translateX(30px);opacity:0}to{transform:none;opacity:1}}' +
    '@media (max-width:640px){.lmqa__panel{top:auto;left:0;right:0;bottom:0;width:100%;max-height:88vh;border-radius:14px 14px 0 0;animation:lmqaUp .25s ease}@keyframes lmqaUp{from{transform:translateY(40px);opacity:0}to{transform:none;opacity:1}}}' +
    '.lmqa__close{position:absolute;top:10px;right:12px;background:none;border:0;font-size:28px;line-height:1;cursor:pointer;color:#121212;padding:4px 8px}' +
    '.lmqa__top{display:flex;gap:16px;margin-bottom:20px}' +
    '.lmqa__img{width:110px;flex:0 0 110px;aspect-ratio:3/4;object-fit:cover;background:#f4f4f4}' +
    '.lmqa__title{font-size:16px;font-weight:600;margin:0 28px 8px 0;line-height:1.3}' +
    '.lmqa__price{font-size:15px}' +
    '.lmqa__compare{text-decoration:line-through;color:#888;margin-left:8px;font-size:14px}' +
    '.lmqa__opt{margin-bottom:18px}' +
    '.lmqa__label{font-size:12px;font-weight:600;letter-spacing:.1em;text-transform:uppercase;margin-bottom:8px}' +
    '.lmqa__label span{font-weight:400;text-transform:none;letter-spacing:0;color:#555}' +
    '.lmqa__vals{display:flex;flex-wrap:wrap;gap:8px}' +
    '.lmqa__val{min-width:48px;padding:10px 12px;border:1px solid #d6d6d6;background:#fff;color:#121212;font-size:13px;cursor:pointer;border-radius:0}' +
    '.lmqa__val.is-selected{border-color:#121212;background:#121212;color:#fff}' +
    '.lmqa__val.is-unavailable{color:#aaa;text-decoration:line-through}' +
    '.lmqa__val.is-selected.is-unavailable{color:#ddd}' +
    '.lmqa__add{display:block;width:100%;padding:16px 10px;background:#121212;color:#fff;border:1px solid #121212;font-size:13px;font-weight:600;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;margin-top:6px}' +
    '.lmqa__add[disabled]{opacity:.45;cursor:not-allowed}' +
    '.lmqa__error{color:#b3261e;font-size:13px;margin-top:10px;min-height:1em}' +
    '.lmqa__details{display:block;text-align:center;margin-top:14px;font-size:13px;color:#121212;text-decoration:underline}' +
    '.lmqa__loading{padding:40px 0;text-align:center;color:#555}' +
    'body.template-product [id$="__main"] .price .price__current{font-weight:700!important;font-size:1.3em!important}' +
    'body.template-product [id$="__main"] .price .price__was{font-weight:400!important;font-size:1em!important}' +
    '.almond-payments{display:flex;flex-wrap:wrap;justify-content:center;align-items:center;gap:8px;margin:14px 0 4px}' +
    '.almond-payments svg{width:38px;height:24px;flex:0 0 auto;display:block;border-radius:3px}' +
    'body.template-product [id$="__main"] .option-selector__btns{gap:6px}' +
    'body.template-product [id$="__main"] .option-selector__btns .opt-label--btn{flex:1 1 0;min-width:38px;max-width:64px;margin:0!important;padding:9px 4px!important;font-size:13px!important;line-height:1.2!important;min-height:0!important}';

  var styleEl = document.createElement('style');
  styleEl.textContent = css;
  document.head.appendChild(styleEl);

  var modal, body, product, options, selected, current, lastOpener;

  function build() {
    if (modal) return;
    modal = document.createElement('div');
    modal.className = 'lmqa';
    modal.innerHTML =
      '<div class="lmqa__overlay" data-lmqa-close></div>' +
      '<div class="lmqa__panel" role="dialog" aria-modal="true" aria-label="Choisissez vos options">' +
      '<button type="button" class="lmqa__close" data-lmqa-close aria-label="Fermer">&times;</button>' +
      '<div class="lmqa__body"></div></div>';
    document.body.appendChild(modal);
    body = modal.querySelector('.lmqa__body');
    modal.addEventListener('click', function (e) {
      if (e.target.closest('[data-lmqa-close]')) close();
      var val = e.target.closest('.lmqa__val');
      if (val) {
        selected[+val.dataset.index] = val.dataset.value;
        update();
      }
      if (e.target.closest('.lmqa__add')) add();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });
  }

  function open(handle, url) {
    build();
    product = null;
    body.innerHTML = '<div class="lmqa__loading">Chargement…</div>';
    modal.classList.add('is-open');
    document.body.classList.add('lmqa-lock');
    fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (p) {
        render(p, url);
      })
      .catch(function () {
        window.location.href = url;
      });
  }

  function close() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('lmqa-lock');
    if (lastOpener && lastOpener.focus) lastOpener.focus();
  }

  function render(p, url) {
    product = p;
    options = (p.options || []).map(function (o, i) {
      if (typeof o === 'string') {
        var vals = [];
        p.variants.forEach(function (v) {
          if (vals.indexOf(v.options[i]) === -1) vals.push(v.options[i]);
        });
        return { name: o, values: vals };
      }
      return { name: o.name, values: o.values };
    });
    var start = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    selected = start.options.slice();

    var single = p.variants.length === 1 && (p.variants[0].title === 'Default Title' || p.variants[0].title === 'Titre par défaut');
    var html = '<div class="lmqa__top"><img class="lmqa__img" alt=""><div>' +
      '<p class="lmqa__title">' + esc(p.title) + '</p>' +
      '<div class="lmqa__price"><span class="lmqa__now"></span><span class="lmqa__compare"></span></div></div></div>';
    if (!single) {
      options.forEach(function (o, i) {
        html += '<div class="lmqa__opt"><div class="lmqa__label">' + esc(o.name) + ' : <span class="lmqa__chosen" data-index="' + i + '"></span></div><div class="lmqa__vals">';
        o.values.forEach(function (val) {
          html += '<button type="button" class="lmqa__val" data-index="' + i + '" data-value="' + esc(val) + '">' + esc(val) + '</button>';
        });
        html += '</div></div>';
      });
    }
    html += '<button type="button" class="lmqa__add">Ajouter au panier</button><div class="lmqa__error" aria-live="polite"></div>' +
      '<a class="lmqa__details" href="' + esc(url) + '">Voir tous les détails</a>';
    body.innerHTML = html;
    update();
  }

  function findVariant(opts) {
    return product.variants.filter(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    })[0];
  }

  function update() {
    current = findVariant(selected);
    body.querySelectorAll('.lmqa__val').forEach(function (b) {
      var i = +b.dataset.index;
      var val = b.dataset.value;
      b.classList.toggle('is-selected', selected[i] === val);
      var test = selected.slice();
      test[i] = val;
      var v = findVariant(test);
      b.classList.toggle('is-unavailable', !v || !v.available);
    });
    body.querySelectorAll('.lmqa__chosen').forEach(function (s) {
      s.textContent = selected[+s.dataset.index] || '';
    });
    var v = current || product.variants[0];
    body.querySelector('.lmqa__now').textContent = money(v.price);
    body.querySelector('.lmqa__compare').textContent = v.compare_at_price && v.compare_at_price > v.price ? money(v.compare_at_price) : '';
    var src = (current && current.featured_image && current.featured_image.src) || product.featured_image;
    var im = body.querySelector('.lmqa__img');
    if (src) im.src = img(src, 300); else im.style.display = 'none';
    var btn = body.querySelector('.lmqa__add');
    body.querySelector('.lmqa__error').textContent = '';
    if (!current) {
      btn.disabled = true;
      btn.textContent = 'Indisponible';
    } else if (!current.available) {
      btn.disabled = true;
      btn.textContent = 'Épuisé';
    } else {
      btn.disabled = false;
      btn.textContent = 'Ajouter au panier';
    }
  }

  function add() {
    if (!current || !current.available) return;
    var btn = body.querySelector('.lmqa__add');
    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: current.id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error(data.description || data.message || "Impossible d'ajouter au panier");
          return data;
        });
      })
      .then(function () {
        btn.textContent = 'Ajouté ✓';
        document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
        var drawer = document.querySelector('.js-cart-drawer');
        setTimeout(function () {
          close();
          if (drawer && typeof drawer.open === 'function') {
            drawer.open();
          }
        }, 400);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = 'Ajouter au panier';
        body.querySelector('.lmqa__error').textContent = err.message;
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.lm-atc');
    if (!btn) return;
    var href = btn.getAttribute('href') || '';
    var m = href.match(/\/products\/([^\/?#]+)/);
    var handle = btn.dataset.handle || (m && decodeURIComponent(m[1]));
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    lastOpener = btn;
    open(handle, href);
  }, true);
})();